export default function auth ({ next, store, nextMiddleware }){
    // console.log('Хук авторизованного хумана');
    if(!store.getters.user.isLogin){
        sessionStorage.setItem('redirect', window.location.href)
        return next({
            name: 'auth'
        });
    }
    return nextMiddleware()
}